<template>
    <q-layout view="hHh lpR fFf">
        <q-page-container>
            <q-page>
                <div class="row">
                    <div class="col" style="min-width: 300px; background-color: #f2f5f7">
                        <div style="margin: 10px; width: 300px">
                            <q-btn flat class="transparent" color="primary" @click="goToLogin">
                                <!-- <img
                                    src="/assets/images/diagnostic/BI.png"
                                    alt="logo"
                                    width="200"
                                    style="display: inline; padding: 0 0 0 4px"
                                /> -->
                                <img src="/assets/images/diagnostic/logo_d.png" alt="logo" width="120" style="display: inline; padding: 0 0 0 4px" />
                            </q-btn>
                            <span style="position: absolute; float: right; top: 26px; left: 144px; color: #657f86; font-weight: bold; font-size: 20px; width: 140px"> &nbsp;독해 트레이닝 </span>
                        </div>
                        <div style="margin: -40px 0 0 0; display: flex; height: 100vh; justify-content: center; align-items: center">
                            <div class="text-h8 text-bold" style="width: 80%; margin: 0 0 0 0">
                                <p style="margin: 0px; padding: 0 0 0 0; font-size: 16px; color: #657f86">KReaD 기반의 국어 지식맵과 수능 유형 트레이닝</p>
                                <h4 class="text-bold" style="padding: 0 0 30px 0">
                                    중학생의 독해 실력을<br />
                                    <h4 class="text-bold text-primary">수능 1등급까지 한번에 UP!</h4>
                                </h4>
                                <div style="font-size: 18px">
                                    독해 트레이닝은 크리드 기반의 지문과 국어 지식맵을 바탕으로 한 문항 구성으로 학습자 수준에 맞는 드릴 학습을 제공합니다. 수능 베이직&심화 유형을 완벽히 트레이닝해 줄 뿐만 아니라, 독서 영역에서 전문성이 높은 글을
                                    접하며 낯선 지문에 대한 적응력을 높여 줍니다.<br />
                                </div>

                                <img src="assets/images/diagnostic/diagnostic_login_left.png" alt="diagnostic_login_left" style="padding: 30px; width: 100%" />
                            </div>
                        </div>
                    </div>
                    <div class="col" style="display: flex; height: 100vh; justify-content: center; align-items: center">
                        <div style="width: 60%; text-align: center">
                            <h4 class="text-bold">독해 트레이닝 진단평가를 위해</h4>

                            <h4 class="text-bold text-primary">로그인 해주세요!</h4>
                            <img src="assets/images/diagnostic/diagnostic_evaluation_right.png" alt="character" style="margin: 5px 0; width: 100%; max-width: 400px" />

                            <q-form @submit="onSubmit" ref="loginFormRef" style="margin: 0 auto">
                                <q-input
                                    outlined
                                    v-model="wId"
                                    style="width: 100%; margin: 0"
                                    bg-color="white"
                                    label="닉네임"
                                    hint=""
                                    @update:model-value="ready"
                                    :rules="[(val) => (val && val.length > 0) || '닉네임을 입력해 주세요.', validMinLength2, validMaxLength20]"
                                >
                                    <!-- <template v-slot:prepend>
                                        <q-icon name="person" />
                                    </template> -->
                                </q-input>

                                <q-select
                                    outlined
                                    class="q-mt-lg"
                                    bg-color="white"
                                    style="width: 100%; margin: 2px 0 0 0"
                                    v-model="wGrade"
                                    :options="optionsGrade"
                                    option-value="value"
                                    option-label="label"
                                    option-disable="inactive"
                                    label="학년"
                                    @update:model-value="ready"
                                    :rules="[(val) => (val && val.label !== '') || '학년을 선택해 주세요.']"
                                >
                                    <!-- <template v-slot:prepend>
                                        <q-icon name="school" />
                                    </template> -->
                                </q-select>
                            </q-form>
                            <q-btn size="lg" style="width: 100%; margin: 2px 0 0 0" class="text-h6" @click="onSubmit" type="submit" :disable="isDisableSubmitBtn" label="로그인" />
                           
                        </div>
                    </div>
                </div>
            </q-page>
        </q-page-container>
    </q-layout>
</template>

<script setup>
import { useQuasar } from 'quasar';
import { ref, reactive, watch, computed } from 'vue';
import { GlobalStore } from '@/store';
import { useRouter } from 'vue-router';
import { postDiagnosticRegister } from '@/api/modules/eval_api.js';
// import { schoolApi } from './school_api.js';
// import { optionsGrade } from '../eval_login/options_custom.jsns_custom.js';

import moment from 'moment';

// console.log('--register-23444-');
const $q = useQuasar();
const router = useRouter();
const globalStore = GlobalStore();

const loginFormRef = ref(null);
const wId = ref(null);
const wGrade = ref(null); // 등급
// const wPassword = ref('12345678QQ##');
// const wName = ref('강대교');
// const wEmail = ref('afsd@asfd.com');
// const wPhoneNumber = ref('010-9999-8888');
// const isPwd = ref(true);
///////////////////////----학교검색----///////////////////////
const onPopSchool = ref(true);
const onPopSchoolSecond = ref(false);
const schoolRegion = ref(null);
const keywordSchool = ref();
const showSearchInfo = ref(false);
const isDisableSubmitBtn = ref(true);
const searchInfo = ref('검색결과가 없습니다.');
const selectedSchool = reactive({
    obj: {},
});
const arrResSchool = reactive({
    state: [],
    arr: [],
});

watch(onPopSchool, (newonPopSchool, oldonPopSchool) => {
    // console.log('--onPopSchool:', newonPopSchool, oldonPopSchool);
    if (newonPopSchool) {
        selectedSchool.obj = {};
        schoolRegion.value = null;
        keywordSchool.value = '';
        arrResSchool.arr = [];
    }
});
watch(schoolRegion, (nschoolRegion, oschoolRegion) => {
    // console.log('--schoolRegion:', nschoolRegion, oschoolRegion);
    // console.log('--keywordSchool-validate-:', keywordSchool.value.validate());
    onSearchSchool();
});
watch(keywordSchool, (newSch, oldSch) => {
    // console.log('--keywordSchool:', newSch, oldSch);
    // console.log('--keywordSchool-validate-:', keywordSchool.value.validate());
    onSearchSchool();
});
const onItemSchool = (itemSch) => {
    selectedSchool.obj = itemSch;
    // console.log('--selectedSchool.obj--', selectedSchool.obj.SCHUL_NM);
    onPopSchoolSecond.value = true;
};

const onSearchSchool = () => {
    if (!schoolRegion.value || !keywordSchool.value) return;

    // console.log('--onSearchSchool:', schoolRegion.value, keywordSchool.value);

    const payload = {
        ATPT_OFCDC_SC_CODE: schoolRegion.value.ATPT_OFCDC_SC_CODE,
        SCHUL_NM: keywordSchool.value,
        type: 'json',
    };
    
    // schoolApi(payload, (data) => {
    //     if (data) {
    //         if (!data.schoolInfo) {
    //             showSearchInfo.value = true;
    //             searchInfo.value = '검색결과가 없습니다.';
    //             arrResSchool.arr = [];
    //             return;
    //         }

    //         showSearchInfo.value = false;
    //         console.log('--onSearchSchool--data.schoolInfo[1].row----:', data.schoolInfo[1].row);
    //         arrResSchool.arr = data.schoolInfo[1].row;
    //     } else {
    //         showSearchInfo.value = true;
    //         searchInfo.value = '관리자에게 문의하세요.';
    //     }
    // });
};

///////////////////////----유효성검사----///////////////////////
const pattern_kor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; // korean
const pattern_eng = /[a-zA-Z]/; // alphabet
const pattern_spc = /[~!@#$%^&*()_+|<>?:{}]/; // sign
const pattern_num = /[0-9]/; // number

const validMinLength2 = (val) => (val.length < 2 ? '한글 또는 영문 2~16자로 입력해 주세요.' : true);
const validMaxLength20 = (val) => (val.length > 16 ? '한글 또는 영문 2~16자로 입력해 주세요.' : true);
const validDenyKorean = (val) => (pattern_kor.test(val) ? '한글은 적을 수 없습니다.' : true);
const validDenyEnglish = (val) => (pattern_eng.test(val) ? '알파벳은 적을 수 없습니다.' : true);
const validDenySign = (val) => (pattern_spc.test(val) ? '특수문자는 적을 수 없습니다.' : true);
const validDenyNumber = (val) => (pattern_num.test(val) ? '숫자는 적을 수 없습니다.' : true);

const validIncludeAt = (val) => (!(val.includes('@') && val.includes('.')) ? '유효한 이메일을 입력해 주세요.' : true);

const validPhoneNo = (val) => (pattern_eng.test(val) || pattern_spc.test(val) || pattern_kor.test(val) ? '숫자와 하이픈(-)만 적을 수 있습니다.' : val.length < 9 ? '유효한 전화번호를 입력해 주세요.' : true);

///////////////////////----Onclick----///////////////////////
watch([wId, wGrade], (aa, bb) => {
    isDisableSubmitBtn.value = !(wId.value && wGrade.value);
});
const ready = (val) => {
    // console.log('--wId--wGrade--', wId.value, wGrade.value);
    // if (wId.value && wGrade.value) isDisableSubmitBtn.value = false;
};
const onSubmit = async () => {
    isDisableSubmitBtn.value = true;
    loginFormRef.value.validate().then(async (isValid) => {
        if (isValid) {
            // gotoPaper2();
            // return;
            // ++globalStore.loginCount;

            const data = await postDiagnosticRegister({
                id: String(wId.value).trim(),
            });
            isDisableSubmitBtn.value = false;
            // console.log('--onSubmit rs :', data);
            if (data)
                if (data.statusCode === '200') gotoPaper(data);
                else $q.dialog({ message: data.message, persistent: true });
            else $q.dialog({ message: 'ERR_NETWORK_CHANGED : 관리자에게 문의하세요.', persistent: true });
        } else {
            isDisableSubmitBtn.value = false;
            $q.notify({
                color: 'red-4',
                textColor: 'white',
                icon: 'cloud_done',
                message: '모든 항목을 입력해 주세요.',
            });
        }
    });
};
 
const gotoPaper = (data) => {
    globalStore.setToken(data.data.accessToken);
    globalStore.setVersion(data.data.version);
    globalStore.setEvalData({
        id: wId.value,
        grade: wGrade.value.grade,
        start_kread: wGrade.value.grade === 'M1' ? 1300 : wGrade.value.grade === 'M2' ? 1400 : wGrade.value.grade === 'M3' ? 1500 : -1,
    });
    router.push('/diagnostic-evaluation');
};

const goToLogin = () => {
    // console.log('gotologin');
    // showResultPop.value = false;
    // globalStore.initUserData();
    router.push('/login');
};

// const gotoEvalQbank = () => {
//     router.push('/evalqbank');
// };
</script>

<style scoped lang="scss">
p,
h4,
h5,
div {
    /* font-family: 'ggg';  */
    /* font-family: "바탕"; */
    font-family: “Noto Sans CJK KR”, Helvetica, sans-serif;
    /* font-weight: normal; */
    /* font-style: normal; */
    // font-size: 16px;
}
@media (max-width: 800px) {
}
// tttb
button:disabled,
button[disabled] {
    // border: 1px solid #999999;
    background-color: #cccccc;
    color: #666666;
}

button {
    background-color: #00a2e0;
    color: #fff;
}

.transparent {
    background-color: transparent;
}
</style>
